<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>

        <v-card class="text-xs-center" v-if="administrador === true">
          <basic-toolbar :title="'Relatórios de gestão'"></basic-toolbar>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field append-icon="filter_list" label="Filtrar resultados" v-model="search"></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
            :headers="headers"
            :items="listaRelatoriosGestao"
            :search="search"
            :no-data-text="'Nenhum projeto encontrado'"
            must-sort
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items-per-page="itemsPerPage"
            :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
            >
              <template v-slot:item.opcoes="props">
                <c-tooltip-btn
                icon="grid_on"
                color="primary"
                tooltip="Baixar planilha"
                @click="goPlanilhaRelatorio(props.item.id, props.item.nome)"
                ></c-tooltip-btn>
              </template>
              <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
                Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaRelatoriosGestao.length }} projetos
              </template>
            </v-data-table>
            <br>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import dates from '@/utils/dates'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    data: () => ({
      api_url: process.env.API_BASE_URL,
      formularioValido: false,
      dates: dates,
      listaRelatoriosGestao: [],
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: -1,
      opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
      headers: [
        { text: 'Número', align: 'center', value: 'id' },
        { text: 'Nome', align: 'center', value: 'nome' },
        { text: 'Descrição', align: 'center', value: 'descricao' },
        { text: 'Opções', align: 'center', value: 'opcoes' }
      ]
    }),
    computed: {
      ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      goPlanilhaRelatorio (id, nome) {
        console.log('asdfahsudfhu')
        window.location = this.api_url + '/gestao/relatorios/' + id + '/' + nome + '.xlsx'
      },
      truncate (string, limit) {
        if (string.length > limit) return string.substring(0, limit) + '...'
        else return string
      },
      carregarRelatoriosGestao: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatórios de gestão.' })
        projetos.getRelatoriosGestao()
        .then(response => {
          this.listaRelatoriosGestao = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.listaRelatoriosGestao = []
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatórios de gestão.' })
        })
      }
    },
    mounted () {
      this.carregarRelatoriosGestao()
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// relatorios-gestao-tabela.vue?60422058